<template>

    <GuideLayout :title="title">

        <div class="flex justify-center font-nexa text-blue text-3xl text-center leading normal">
            {{ __('Your exercises') }}
        </div>


        <div class="font-nexa text-center text-black text-opacity-60 text-xl mt-4 leading-normal">
            {{
                __('We recommend that you workout your entire body and try the individual exercises and then continuously decide')
            }}
            <br/>
            {{ __('to remove exercises you don\'t find suitable for your workout.') }}
        </div>


        <div class="grid gap-7 grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 grid-rows-2 mt-8 select-none w-full">

            <div class="flex flex-row items-center bg-white rounded-lg p-4 border-2 h-28 cursor-pointer xl:w-[290px]"
                v-for="(category,key) of categories"
                :key="category.id"
                :class="{
                    'border-blue' : ! category.active,
                    'opacity-50' : ! category.active,
                    'border-red' : category.active,
                }"
                @click="handle_click_category(key)">

                <img class="w-14 mr-10"
                    :src="category.icon_url"
                    :alt="category.name" />

                <div>

                    <div class="text-xl font-bold text-blue mb-4">
                        {{ category.name }}
                    </div>

                    <div class="flex items-center text-md font-bold text-blue">

                        <font-awesome-icon
                            :icon="[`${ category.active ? 'fas' : 'far'}`, 'heart']"
                            style="width: 20px; height: 20px;"
                            class="mr-2 bg-white"
                            :class="{
                                'text-red': category.active,
                                'text-blue': ! category.active
                            }">
                        </font-awesome-icon>

                        {{ category.exercises_count }}

                    </div>

                </div>

            </div>

        </div>

        <div class="text-lg font-nexa font-bold text-black opacity-60 mt-10 mb-4">
            {{
                __(':chosen of :total exercise categories chosen', {
                    chosen: active_categories_count,
                    total: total_categories_count
                })
            }}
        </div>


        <div class="text-red font-bold mb-8"
            :class="{
                'opacity-0' : active_categories_count >= 1
            }">{{ __('Your need to choose minimum 3 exercise categories') }}</div>


        <div class="mx-auto flex flex-col justify-start items-center xl:flex-row xl:justify-center xl:items-start">

            <template v-if="! is_change_exercises">

                <Button class="mt-10 bg-blue bg-opacity-0 border border-gray-400 text-2xl text-black pl-12 pr-12 pt-5 pb-4 xl:mr-10 hover:opacity-40 hover:text-white"
                    @click="handle_click_previous">

                    {{ __('Previous') }}

                </Button>

                <Button class="mt-10 mb-10 text-2xl pl-12 pr-12 pt-5 pb-4"
                    :disabled="active_categories_count < 1"
                    @click="handle_click_next">

                    {{ __('Next') }}

                </Button>

            </template>


            <template v-if="is_change_exercises">

                <Button class="my-10 text-2xl px-12 pt-5 pb-4 mr-8"
                        @click="$inertia.visit( route('your_exercises') )">

                    {{ __('Go Back') }}

                </Button>

                <Button class="my-10 text-2xl px-12 pt-5 pb-4 bg-green"
                        :disabled="active_categories_count < 1"
                        @click="handle_change_exercises">

                    {{ __('Save Exercises') }}

                </Button>

            </template>

        </div>


    </GuideLayout>

</template>

<script>
import {defineComponent} from "vue";
import GuideLayout from "@/Layouts/GuideLayout";
import Logo from "@/Components/Logo";
import Button from "@/Components/Button";
import Link from "@/Components/Button";

export default defineComponent({

    name: "StartupGuideChoseCategories",


    components: {
        Logo,
        GuideLayout,
        Button,
        Link
    },


    props: {
        categories: {
            type: Array
        },
        is_change_exercises: {
            type: Boolean,
            default: false
        }
    },



    computed: {

        title() {

            return this.__('Startup Guide, Chose Categories');

        },


        total_categories_count() {

            return this.categories.length;

        },


        active_categories_count() {

            return _.filter( this.categories, { active: true }).length;

        },

    },


    methods: {

        handle_click_next() {

            this.$inertia.patch(
                this.route('user_set_exercises_by_active_categories'),
                {
                    categories: this.categories,
                },
                {
                    preserveScroll: true,
                    onSuccess: () => {

                        this.$inertia.visit(
                            this.route('startup_guide_notifications')
                        );

                    }
                }
            );

        },


        handle_click_previous() {

            this.$inertia.patch(
                this.route('user_set_exercises_by_active_categories'),
                {
                    categories: this.categories,
                },
                {
                    preserveScroll: true,
                    onSuccess: () => {

                        this.$inertia.visit(
                            this.route('startup_guide_introduction')
                        );

                    }
                }
            );

        },


        handle_click_category(key) {

            this.categories[key].active = ! this.categories[key].active;

        },


        handle_change_exercises() {

            this.$inertia.patch(
                this.route('user_set_exercises_by_active_categories'),
                {
                    categories: this.categories,
                },
                {
                    preserveScroll: false,
                    onSuccess: () => {

                        this.$inertia.visit(
                            this.route('your_exercises')
                        );

                    }
                }
            );

        }
    }

});
</script>

<style scoped>

</style>
